















import { listFactory } from '@/main/pages';
import { dropdownListProvider } from '@/main/dropdownApi';

import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	methods: {
		onVyrobekvozOznChange() {
			if (!this.VyrobekvozOzn || this.VyrobekvozOzn === '') {
				this.dropdownList.Tablpozice = [];
				this.dropdownList.Typkod = [];
			} else {
				dropdownListProvider.GetTablPoz(this.VyrobekvozOzn!).then(({ data }) => {
					this.dropdownList.Tablpozice = data;
					this.dropdownList.Typkod = [];
				});
			}
		},
		onTablpoziceChange(Tablpozice : number | string) {
			if (Tablpozice) {
				dropdownListProvider.GetTypKodMin4(this.VyrobekvozOzn!, this.Tablpozice!).then(({ data }) => {
					this.dropdownList.Typkod = data;
				});
			} else {
				this.dropdownList.Typkod = [];
				this.Typkod = null;
			}
		},
	},
});
